namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    export interface GroupManagerOptions {
        tableControl: DataTableControl;
        groups: any[];
        aggregates: any[];
        groupBy: any[];        
    }

    /*
     * options:
     *  groupBy: array of groupByEntry
     *  groups: array of group settings passed into DataTableControl settings
     * 
     * {groupByEntry} is a group/column id or:
     *      id: column id     
     */
    export class GroupManager {

        public tableControl: DataTableControl;
        public _groupsSettings;
        public _aggregateSettings;
        public _groups;
        public _groupIdToGroupMap;
        public _aggregates;
        public _groupBy;


        constructor(options: GroupManagerOptions) {
            var self = this;

            this.tableControl = options.tableControl;

            this._groupsSettings = Solovis.isNotNull(options.groups) ? options.groups : null;
            this._aggregateSettings = Solovis.isNotNull(options.aggregates) ? options.aggregates : null;

            this._groups = [];
            this._groupIdToGroupMap = {};

            this._aggregates = [];        

            this._groupBy = [];
            this.updateGroupByList(options.groupBy);
        }

        public updateGroupByList(groupBy) {
            var newGroupByList = [];

            $(groupBy).each(function (i, entry) {
                var groupByEntry;
                if (typeof entry == "string") {
                    groupByEntry = {
                        id: entry
                    };
                }
                else {
                    groupByEntry = entry;
                }

                newGroupByList.push(groupByEntry);
            });

            this._groupBy = newGroupByList;

            if (this.tableControl.expansionManager) {
                // Reset the flattening settings.
                this.tableControl.expansionManager.unflattenAll(true /* suppressNotification */);
            }

            this.notifyGroupByChanged();
        }

        public alsoGroupBy(groupByEntry) {
            this._groupBy.push(groupByEntry);

            this.notifyGroupByChanged();
        }

        public notifyGroupByChanged() {
            $(this).trigger("groupByChanged");
        }

        public notifyGroupsChanged() {
            $(this).trigger("groupsChanged");
        }

        public getGroupByList() {
            var groupByList = [];

            $(this._groupBy).each(function (i, entry) {
                var entryCopy = {
                    id: entry.id
                };

                groupByList.push(entryCopy);
            });

            return groupByList;
        }

        public ungroupById(groupId) {
            let groupByList = this.getGroupByList();

            let updatedList = _.filter(
                groupByList as any,
                (entry: any) => {
                    if (entry.id !== groupId) {
                        return true;
                    }
                });

            this.updateGroupByList(updatedList);
        }

        public isGroupedById(groupId) {
            if (this._groupBy) {
                for (let entry of this._groupBy) {
                    if (entry.id === groupId) {
                        return true;
                    }
                }
            }

            return false;
        }

        public getGroupById(groupId) {
            if (this._groupIdToGroupMap[groupId]) {
                return this._groupIdToGroupMap[groupId];
            }

            return null;
        }

        public getAvailableGroups() {
            return this._groups.slice(0);
        }


        public updateGroups() {
            var self = this;

            // Update groups.
            var groups = [];
            var groupIdToGroupMap = {};
            if (this._groupsSettings) {
                var groupSourceList;
                if (typeof this._groupsSettings == "function") {
                    groupSourceList = this._groupsSettings.call(this.tableControl);
                }
                else {
                    groupSourceList = this._groupsSettings;
                }

                this._tryToAutoFillTagIdGroups(groupSourceList);

                $(groupSourceList).each(function (i, group) {
                    groups.push(group);
                    groupIdToGroupMap[group.id] = group;
                });
            }

            if (!groupIdToGroupMap["all"]) {
                // Add "All" group if it is not present. We don't always add this since there are a number of reports that already add this themselves.
                var allGroup = {
                    id: "all",
                    field: function () { return true; },
                    label: "All",
                    htmlFormatter: function () {
                        return "All";
                    }
                };

                groups.splice(0, 0, allGroup);
                groupIdToGroupMap[allGroup.id] = allGroup;
            }

            // Determine which columns we need to override aggregate settings for.
            var colList = this.tableControl.columnSet.getColumnList();
            $(colList).each(function (i, col: any) {
                var colDefToUse = col.definitionToUse;

                let useStandardGrouping = false;
                if (colDefToUse.applyStandardGrouping) {
                    useStandardGrouping = true;
                }
                else if (Solovis.isNull(colDefToUse.applyStandardGrouping)) {
                    switch (colDefToUse.dataType) {
                        case "string":
                        case "tagId":
                        case "bool":
                        case "dayId":
                        case "currencyId":
                        case "valueTypeId":
                            useStandardGrouping = true;
                            break;
                    }
                }

                if (useStandardGrouping) {
                    // Only use standard grouping if explicit grouping was not already created.
                    if (!groupIdToGroupMap[col.id]) {
                        var standardGroup: any = {
                            id: col.id,
                            field: colDefToUse.field,
                            dataType: colDefToUse.dataType ? colDefToUse.dataType : null,
                            label: col.getCompositeLabel(),
                            htmlFormatter: colDefToUse.htmlFormatter ? colDefToUse.htmlFormatter : null,
                            formatHint: colDefToUse.formatHint ? colDefToUse.formatHint : null
                        };

                        if (colDefToUse.dataType == "tagId") {
                            standardGroup.topLevelRowForNullGroup = false;
                            standardGroup.tagSetId = colDefToUse.tagSetId;
                            standardGroup.multiLevel = {};
                            standardGroup.formatHint = { standardLinks: true };
                        }

                        // See if this will override an existing group definition.
                        if (groupIdToGroupMap[standardGroup.id]) {
                            groups = _.filter(groups, function (group) { return group.id !== standardGroup.id; });
                            delete groupIdToGroupMap[standardGroup.id];
                        }

                        // Add this new standard group to the available group maps.
                        groups.push(standardGroup);
                        groupIdToGroupMap[standardGroup.id] = standardGroup;
                    }
                }
            });

            groups = _.sortBy(groups, 'label');

            this._groups = groups;
            this._groupIdToGroupMap = groupIdToGroupMap;


            // Filter out groupBy fields if the group does not exist (could be case because of initial configuration).
            this._groupBy = _.filter(this._groupBy, function (entry: any) { return groupIdToGroupMap[entry.id] ? true : false });

            // Update aggregates when we update groups.
            this._updateAggregates();

            this.notifyGroupsChanged();
        };


        public _updateAggregates() {
            var aggregates = [];
            if (this._aggregateSettings) {
                var aggregateSourceList;
                if (typeof this._aggregateSettings == "function") {
                    aggregateSourceList = this._aggregateSettings.call(this.tableControl);
                }
                else {
                    aggregateSourceList = this._aggregateSettings;
                }

                $(aggregateSourceList).each(function (i, aggregate) {
                    aggregates.push(aggregate);
                });
            }

            var aggregateIdToAggregateMap = {};
            $(aggregates).each(function (i, aggregate) {
                aggregateIdToAggregateMap[aggregate.id] = aggregate;
            });

            // Determine which columns we need to override aggregate settings for.
            var visibleColumnDefs = this.tableControl.columnSet.getVisibleColumnDefinitions();
            $(visibleColumnDefs).each(function (i, visibleColumnDef: any) {
                if (visibleColumnDef.aggregation && visibleColumnDef.aggregation.aggregator) {
                    // Override the aggregator in use for that column id or add new one.
                    var customAggregate: any = {}
                    for (var property in visibleColumnDef.aggregation) {
                        if (visibleColumnDef.aggregation.hasOwnProperty(property)) {
                            customAggregate[property] = visibleColumnDef.aggregation[property];
                        }
                    }
                    customAggregate.id = visibleColumnDef.id;
                    if (visibleColumnDef.field) {
                        customAggregate.field = visibleColumnDef.field;
                    }
                    aggregateIdToAggregateMap[visibleColumnDef.id] = customAggregate;
                }
            });

            // Rebuild aggregates from map with overrides applied.
            var aggregates = [];
            for (var key in aggregateIdToAggregateMap) {
                if (aggregateIdToAggregateMap.hasOwnProperty(key)) {
                    var aggregate = aggregateIdToAggregateMap[key];
                    aggregates.push(aggregate);
                }
            }

            this._aggregates = aggregates;
        }


        public _tryToAutoFillTagIdGroups(groupList) {
            var self = this;
            // This will try to auto-setup multiLevel and topLevelRowForNullGroup if they are not explicitly set on a tagId column.
            $(groupList).each(function (i, group: any) {
                if (group.dataType == "tagId" && group.tagSetId) {
                    if (typeof group.topLevelRowForNullGroup == "undefined" || typeof group.multiLevel == "undefined") {
                        var modelEnv = self.tableControl.modelEnvironment;
                        if (modelEnv && modelEnv.tagSets) {
                            var tagSet = self.tableControl.modelEnvironment.tagSets.tryGetById(group.tagSetId);
                            if (tagSet) {
                                if (typeof group.topLevelRowForNullGroup == "undefined") {
                                    group.topLevelRowForNullGroup = false;
                                }
                                if (typeof group.multiLevel == "undefined") {
                                    group.multiLevel = tagSet.getLevelInfoGetter();
                                }
                            }
                        }
                    }
                }
            });
        };


        /**
         * Group and aggregate the rows based on current settings
         * @param rowList
         */
        public groupAndAggregate(rowList) {
            var baseNestedGroupKey = null;
            var processedRows = this._groupRows(baseNestedGroupKey, rowList, this._groupBy);

            var grandTotals = null;
            if (this._aggregates && this._aggregates.length > 0) {
                grandTotals = this._aggregateRows(processedRows);
            }

            var result = {
                processedRows: processedRows,
                grandTotals: grandTotals
            };

            return result;
        }


        public _groupRows(baseNestedGroupKey, rowList, groupByList) {
            if (!rowList) {
                return null;
            }

            var self = this;
            var modelEnvironment = this.tableControl.modelEnvironment ? this.tableControl.modelEnvironment : null;

            if (groupByList && groupByList.length > 0) {
                var groupByEntry = groupByList[0];
                var groupId = groupByEntry.id;
                var remainingGroupByList = groupByList.slice(1);

                var group = this._groupIdToGroupMap[groupId];
                if (!group) {
                    throw "Group not found: " + groupId;
                }

                var groupings = {};
                var groupList = [];

                var nestedGroupKeyToGroupingMap = {};

                var getGroupValue = function (row) {
                    var groupFieldType = typeof group.field;
                    if (groupFieldType == "string") {
                        return Solovis.resolveObject(group.field, row);
                    }
                    else if (groupFieldType == "function") {
                        return group.field(row);
                    }
                    return null;
                };

                var notSetKey = "***NOT SET***";

                var getGroupKey = function (groupValue) {
                    if (groupValue === null || typeof (groupValue) == "undefined") {
                        return notSetKey;
                    }
                    else {
                        return groupValue.toString();
                    }
                };

                var getGroupRep = function (groupValue, row?) {
                    return groupValue;
                };

                var getOrCreateGrouping = null;
                getOrCreateGrouping = function (groupValue) {
                    var groupParentValue = null;

                    var rowLevelInfo = null;
                    if (group.multiLevel) {
                        if (!group.multiLevel.levelInfoGetter) {
                            // See if we can auto initialize levelInfoGetter.
                            if (modelEnvironment && group.tagSetId) {
                                var tagSet = modelEnvironment.tagSets.tryGetById(group.tagSetId);
                                if (tagSet) {
                                    group.multiLevel.levelInfoGetter = tagSet.getLevelInfoGetter();
                                }
                            }
                        }

                        if (group.multiLevel.levelInfoGetter) {
                            rowLevelInfo = group.multiLevel.levelInfoGetter(groupValue);
                        }

                        if (rowLevelInfo) {
                            if (typeof (group.multiLevel.maxLevelToShow) == "number") {
                                if (rowLevelInfo.level > group.multiLevel.maxLevelToShow) {
                                    return getOrCreateGrouping(rowLevelInfo.parent);
                                }
                            }
                        }
                    }

                    var groupKey = getGroupKey(groupValue);

                    var grouping = null;

                    if (groupings[groupKey]) {
                        grouping = groupings[groupKey];
                    }
                    else {
                        grouping = {
                            _groupKey: groupKey,
                            _groupId: groupId,
                            _groupRep: getGroupRep(groupValue),
                            _rows: []
                        };

                        var parentGroup = null;
                        if (rowLevelInfo && rowLevelInfo.parent !== null && typeof rowLevelInfo.parent != "undefined") {
                            parentGroup = getOrCreateGrouping(rowLevelInfo.parent);
                            if (parentGroup) {
                                grouping._groupParentKey = parentGroup._groupKey;
                            }
                        }

                        var nestedGroupKey;
                        if (parentGroup) {
                            nestedGroupKey = parentGroup._nestedGroupKey + "||" + groupKey;
                        }
                        else {
                            nestedGroupKey = groupId + "::" + groupKey;

                            if (baseNestedGroupKey) {
                                nestedGroupKey = baseNestedGroupKey + nestedGroupKey;
                            }
                        }

                        var flattenedNestedGroupKey = self.tableControl.expansionManager.getFlattenedNestedGroupKeyIfWithinFlattenedSubGroup(nestedGroupKey);
                        if (flattenedNestedGroupKey) {
                            var flattenedGrouping = nestedGroupKeyToGroupingMap[flattenedNestedGroupKey];
                            if (flattenedGrouping) {
                                return flattenedGrouping;
                            }
                            else {
                                // The flattened grouping was at a higher grouping level, so return null so 
                                // that this goes in top-level rows.                            
                                return null;
                            }
                        }

                        grouping._nestedGroupKey = nestedGroupKey;
                        nestedGroupKeyToGroupingMap[nestedGroupKey] = grouping;

                        groupings[groupKey] = grouping;
                        groupList.push(grouping);
                    }

                    return grouping;
                };


                var placeNormalRowInGrouping = function (row) {
                    var groupValue = getGroupValue(row);

                    var grouping = getOrCreateGrouping(groupValue);
                    if (grouping) {
                        grouping._rows.push(row);
                    }
                    else {
                        // Group has been flattened, so there is no group. Rows are included
                        // at top level.
                        groupList.push(row);
                    }
                };

                $(rowList).each(function (i, row) {
                    if (!group.dataRowsForGroups) {
                        placeNormalRowInGrouping(row);
                    }
                    else {
                        // Some rows must be associated directly with a group node since the group nodes must be data rows.
                        // group.groupValueField identifies the field that identifies the row as a group row.
                        var rowAsGroupValue = Solovis.resolveObject(group.groupValueField, row);
                        if (Solovis.isNotNull(rowAsGroupValue)) {
                            // This is a group row, so associate it with the grouping.
                            var grouping = getOrCreateGrouping(rowAsGroupValue);
                            if (grouping) {
                                grouping._backingRow = row;
                            }
                            else {
                                console.log("ERROR: grouping row not found");
                            }
                        }
                        else {
                            placeNormalRowInGrouping(row);
                        }
                    }
                });

                if (remainingGroupByList) {
                    $(groupList).each(function (i, grouping: any) {
                        grouping._rows = self._groupRows(grouping._nestedGroupKey + "//", grouping._rows, remainingGroupByList);
                    });
                }

                if (group.topLevelRowForNullGroup) {
                    if (groupings[notSetKey]) {
                        // We need to create new list where null-group rows are at top-level.
                        var notSetGrouping = groupings[notSetKey];

                        var newGroupList = [];
                        $(notSetGrouping._rows).each(function (i, nullGroupRow) {
                            newGroupList.push(nullGroupRow);
                        });

                        $(groupList).each(function (i, grouping: any) {
                            if (grouping._groupKey != notSetKey) {
                                newGroupList.push(grouping);
                            }
                        });

                        groupList = newGroupList;
                    }
                }

                if (group.multiLevel || group.dataRowsForGroups) {
                    var newGroupList = [];

                    var getGroupParentKeyForGrouping = function (grouping) {
                        if (group.dataRowsForGroups) {
                            var groupValueForGrouping = getGroupValue(grouping._backingRow);
                            var groupingGroupKey = getGroupKey(groupValueForGrouping);
                            return groupingGroupKey;
                        }
                        else {
                            return grouping._groupParentKey;
                        }
                    };

                    $(groupList).each(function (i, grouping) {
                        var groupParentKey = getGroupParentKeyForGrouping(grouping);
                        if (Solovis.isNull(groupParentKey) || groupParentKey === notSetKey) {
                            newGroupList.push(grouping);
                        }
                        else {
                            var parentGrouping = groupings[groupParentKey];
                            if (parentGrouping) {
                                parentGrouping._rows.push(grouping);
                            }
                        }
                    });

                    groupList = newGroupList;
                }

                return groupList;
            }
            else {
                return rowList;
            }
        }

        public _aggregateRows(rows) {
            let self = this;

            let totals = {};
            let aggregators = this._getAggregators();

            $(aggregators).each(function (i, aggregator: any) {
                if (aggregator.init) {
                    aggregator.init(totals);
                }
            });

            let getValueToAggregate = function (aggregator, row) {
                let id = aggregator.id;

                if (row._groupTotals) {
                    if (row._groupTotals[id]) {
                        return row._groupTotals[id];
                    }
                    else {
                        return null;
                    }
                }

                let aggregateFieldType = typeof aggregator.field;
                if (aggregateFieldType == "string") {                    
                    return Solovis.resolveObject(aggregator.field, row);                    
                }
                else if (aggregateFieldType == "function") {
                    return aggregator.field(row);
                }
                else {                    
                    let colForId = self.tableControl.columnSet.getColumnById(id);
                    if (colForId) {
                        var colForIdDef = colForId.definitionToUse;
                        var cellValue = self.tableControl._getColumnValueForRow(colForIdDef, row);
                        return cellValue;
                    }
                    else {
                        if (typeof row[id] !== "undefined") {
                            return row[id];
                        }
                    }                    
                }
                return null;
            };

            $(rows).each(function (i, row: any) {
                var isGroupRow = false;

                if (row._groupId) {
                    isGroupRow = true;
                    let subTotals = self._aggregateRows(row._rows);
                    row._groupTotals = subTotals;
                }

                let processSubRows = function (subRow, aggregator) {
                    if (subRow._rows) {
                        for (let childSubRow of subRow._rows) {
                            if (!childSubRow._groupId) {
                                let value = getValueToAggregate(aggregator, childSubRow);
                                aggregator.accumulate(value, totals, false, childSubRow);
                            }
                            else {
                                processSubRows(childSubRow, aggregator);
                            }
                        }
                    }
                };

                // List of column ids where we should aggregate using the function.
                let aggFormulaColIds = [];

                $(aggregators).each(function (i, aggregator: any) {
                    if (!aggregator.useFormula) {
                        if (isGroupRow && aggregator.flatMode) {
                            // In flat mode, we are required to always look at individual rows as a whole (for instance, uniqueCount requires this).
                            processSubRows(row, aggregator);
                        }
                        else {
                            let value = getValueToAggregate(aggregator, row);
                            aggregator.accumulate(value, totals, isGroupRow, row);
                        }
                    }
                    else {
                        aggFormulaColIds.push(aggregator.columnId);
                    }
                });

                $(aggFormulaColIds).each(function (i, aggFormulaColId: any) {
                    if (row._groupId) {
                        let col = self.tableControl.columnSet.getColumnById(aggFormulaColId);
                        if (col) {                            
                            let value = self.tableControl._getColumnValueForRow(col, row);
                            row._groupTotals[aggFormulaColId] = value;
                        }
                    }                    
                });

            });

            return totals;
        };

        public _getAggregators() {
            var self = this;

            var aggregators = [];

            $(this._aggregates).each(function (i, aggregate: any) {
                if (typeof aggregate.aggregator == "object") {
                    aggregators.push({
                        id: aggregate.id,

                        field: aggregate.field ? aggregate.field : null,

                        init: aggregate.aggregator.init,

                        accumulate: aggregate.aggregator.accumulate
                    });
                }
                else if (typeof aggregate.aggregator == "string") {
                    self._createAggregatorByStringType(aggregate.aggregator, aggregate, aggregators);
                }
            });

            return aggregators;
        }


        public _createAggregatorByStringType(aggregatorType, aggregate, aggregators) {
            let self = this;

            if (aggregatorType == "sum") {
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = 0;
                    },

                    accumulate: function (value, totals) {
                        if (typeof value == "number") {
                            totals[this.id] += value;
                        }
                    }
                });
            }
            else if (aggregatorType == "min") {
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = null;
                    },

                    accumulate: function (value, totals) {
                        if (typeof value == "number") {
                            if (Solovis.isNotNull(totals[this.id])) {
                                totals[this.id] = Math.min(totals[this.id], value);
                            }
                            else {
                                totals[this.id] = value;
                            }
                        }
                    }
                });
            }
            else if (aggregatorType == "max") {
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = null;
                    },

                    accumulate: function (value, totals) {
                        if (typeof value == "number") {
                            if (Solovis.isNotNull(totals[this.id])) {
                                totals[this.id] = Math.max(totals[this.id], value);
                            }
                            else {
                                totals[this.id] = value;
                            }
                        }
                    }
                });
            }
            else if (aggregatorType == "mean") {
                // We'll need the count and the sum.
                var sumAggregate = Solovis.deepCopy(aggregate);
                sumAggregate.id = sumAggregate.id + "__sum";
                sumAggregate.field = aggregate.field ? aggregate.field : aggregate.id;
                sumAggregate.aggregator = "sum";
                this._createAggregatorByStringType(sumAggregate.aggregator, sumAggregate, aggregators);

                var countAggregate = Solovis.deepCopy(aggregate);
                countAggregate.id = countAggregate.id + "__count";
                countAggregate.field = aggregate.field ? aggregate.field : aggregate.id;
                countAggregate.aggregator = "count";
                this._createAggregatorByStringType(countAggregate.aggregator, countAggregate, aggregators);

                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = null;
                    },

                    accumulate: function (value, totals, isGroupRow) {
                        var sum = totals[sumAggregate.id];
                        var count = totals[countAggregate.id];
                        if (Solovis.isNotNull(sum) && count) {
                            totals[this.id] = sum / count;
                        }
                    }
                });
            }
            else if (aggregatorType == "meanIfNotNull") {
                // We'll need the count and the sum.
                var sumAggregate = Solovis.deepCopy(aggregate);
                sumAggregate.id = sumAggregate.id + "__sum";
                sumAggregate.field = aggregate.field ? aggregate.field : aggregate.id;
                sumAggregate.aggregator = "sum";
                this._createAggregatorByStringType(sumAggregate.aggregator, sumAggregate, aggregators);

                var countAggregate = Solovis.deepCopy(aggregate);
                countAggregate.id = countAggregate.id + "__countIfNotNull";
                countAggregate.field = aggregate.field ? aggregate.field : aggregate.id;
                countAggregate.aggregator = "countIfNotNull";
                this._createAggregatorByStringType(countAggregate.aggregator, countAggregate, aggregators);

                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = null;
                    },

                    accumulate: function (value, totals, isGroupRow) {
                        var sum = totals[sumAggregate.id];
                        var count = totals[countAggregate.id];
                        if (Solovis.isNotNull(sum) && count) {
                            totals[this.id] = sum / count;
                        }
                    }
                });
            }
            else if (aggregatorType == "count") {
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = 0;
                    },

                    accumulate: function (value, totals, isGroupRow) {
                        if (isGroupRow) {
                            totals[this.id] += value;
                        }
                        else {
                            totals[this.id] += 1;
                        }
                    }
                });
            }
            else if (aggregatorType == "countIfNotNull") {
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = 0;
                    },

                    accumulate: function (value, totals, isGroupRow) {
                        if (Solovis.isNotNull(value)) {
                            if (isGroupRow) {
                                totals[this.id] += value;
                            }
                            else {
                                totals[this.id] += 1;
                            }
                        }
                    }
                });
            }
            else if (aggregatorType == "uniqueCount") {
                var uniqueSetKey = aggregate.id + "||_uniqueSet";

                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[uniqueSetKey] = {};
                        totals[this.id] = 0;
                    },

                    // flatMode = true means that sub-totals can be processed separately for sub-groups and added up. We have to process all rows at once for each line item total.
                    flatMode: true,

                    accumulate: function (value, totals, isGroupRow) {
                        if (isGroupRow) {
                            console.log("ERROR: groupRows shouldn't process through this code path since flatMode=true is set on aggregator.");
                        }
                        else {
                            let uniqueSet = totals[uniqueSetKey];
                            if (!uniqueSet[value]) {
                                uniqueSet[value] = true;
                                totals[this.id] += 1;
                            }
                        }
                    }
                });
            }
            else if (aggregatorType == "uniqueCountIfNotNull") {
                var uniqueSetKey = aggregate.id + "||_uniqueSet";

                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[uniqueSetKey] = {};
                        totals[this.id] = 0;
                    },

                    // flatMode = true means that sub-totals can be processed separately for sub-groups and added up. We have to process all rows at once for each line item total.
                    flatMode: true,

                    accumulate: function (value, totals, isGroupRow) {
                        if (isGroupRow) {
                            console.log("ERROR: groupRows shouldn't process through this code path since flatMode=true is set on aggregator.");
                        }
                        else {
                            if (Solovis.isNotNull(value)) {
                                let uniqueSet = totals[uniqueSetKey];
                                if (!uniqueSet[value]) {
                                    uniqueSet[value] = true;
                                    totals[this.id] += 1;
                                }
                            }
                        }
                    }
                });
            }
            else if (aggregatorType == "valueIfSame") {
                // Will use the value in the field as long as it is the same value.
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        delete totals[this.id];
                    },

                    accumulate: function (value, totals) {
                        if (typeof (totals[this.id]) == "undefined") {
                            totals[this.id] = value;
                        }
                        else if (value !== totals[this.id]) {
                            totals[this.id] = null;
                        }
                    }
                });
            }
            else if (aggregatorType === "pickOne") {
                // Will use the value in the field as long as it is the same value.
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        delete totals[this.id];
                    },

                    accumulate: function (value, totals) {
                        if (Solovis.isNull(totals[this.id])) {
                            totals[this.id] = value;
                        }
                    }
                });
            }
            else if (aggregatorType == "currencySum") {
                if (!aggregate.currencyPropertyId) {
                    console.log("Warning: currencyPropertyId not set on currencySum aggregate with id=" + aggregate.id);
                }

                // NOTE: The currencyPropertyId valueIfSame aggregator should always be specified prior to any currencySum aggregators that rely on it.
                // We will add up the values as long as the currencyId property on the row is valid (differing currencies should invalidate that).
                aggregators.push({
                    id: aggregate.id,

                    field: aggregate.field ? aggregate.field : null,

                    init: function (totals) {
                        totals[this.id] = 0;
                    },

                    accumulate: function (value, totals) {
                        if (Solovis.isNull(totals[aggregate.currencyPropertyId])) {
                            delete totals[this.id];
                        }
                        else if (typeof value == "number") {
                            totals[this.id] += value;
                        }
                    }
                });
            }
            else if (aggregatorType == "formula") {
                aggregators.push({
                    id: aggregate.id,

                    useFormula: true,
                    columnId: aggregate.id
                });
            }
            else if (aggregatorType === "weightedHarmonicMean") {
                let weightedHarmonicMeanDenominatorId = aggregate.id + "||_weightedHarmonicMean.denominator";
                let weightedHarmonicMeanWeightId = aggregate.id + "||_weightedHarmonicMean._weight";

                let weightColumn = self.tableControl.columnSet.getColumnById(aggregate.weightColumnId);
                if (weightColumn) {
                    aggregators.push({
                        id: aggregate.id,

                        flatMode: true,

                        field: aggregate.field ? aggregate.field : null,

                        init: function (totals) {
                            totals[weightedHarmonicMeanDenominatorId] = 0;
                            totals[weightedHarmonicMeanWeightId] = 0;
                            totals[this.id] = 0;
                        },

                        accumulate: function (value, totals, isGroupRow, row) {
                            let weight = self.tableControl._getColumnValueForRow(weightColumn, row);

                            if (typeof value == "number") {
                                if (Solovis.isNotNull(totals[this.id])) {                                    
                                    totals[weightedHarmonicMeanDenominatorId] += weight / value;
                                    totals[weightedHarmonicMeanWeightId] += weight;

                                    let newDenominator = totals[weightedHarmonicMeanDenominatorId];
                                    let newTotalWeight = totals[weightedHarmonicMeanWeightId];

                                    totals[this.id] = newTotalWeight / newDenominator;
                                }
                            }
                            else {
                                // We have encountered a null value on a non-zero weight line and will no longer try to get weighted harmonic mean.
                                if (weight) {
                                    totals[this.id] = null;
                                }
                            }
                        }
                    });
                }
            }
        }
    }

}
